export default (values, legalRepresentativeAval) => ({
  ...values,
  avals: legalRepresentativeAval
    ? [
        {
          ...values.avals,
          ...legalRepresentativeAval
        }
      ]
    : values.avals || [],
  isLegalRepresentativeAnAval: values.isLegalRepresentativeAnAval || false
});
